export default "__VITE_ASSET__7bRsKuMs__"